import { cn } from "@/lib/utils";
import * as shared from "@/styles/shared";

const statsGrid = "mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4";

const pageEnter = "page-enter";

const animateSlideUp = "animate-slide-up";

const chartsGrid = "mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2";

const chartCard = cn(shared.transitionDefault, "hover:border-primary/25");

const chartCardHeader = "pb-2 pt-5";

const chartHeaderRow = "flex items-center gap-2.5";

const chartHeaderIcon = cn(shared.rowCenter, "rounded-lg bg-primary/10 text-primary p-1.5");

const chartTitle = "text-base font-semibold tracking-tight";

const gridLine = "stroke-border/60";

const chartAxis = "text-xs";

const barFill = "fill-primary/70";

const glassTooltip = "rounded-xl border bg-card shadow-elevated p-3 text-foreground text-xs";

const tooltipLabel = "font-semibold mb-1.5 pb-1.5 border-b border-border/50 text-foreground";

const tooltipRow = "flex items-center gap-2 mb-1 last:mb-0";

const tooltipDot = "w-2.5 h-2.5 rounded-full shrink-0";

const tooltipValue = "text-foreground/80";

const pieLegend = "flex flex-col gap-2 sm:min-w-[160px]";

const pieLegendItem = "flex items-center gap-2.5 text-sm";

const pieLegendDot = "w-3 h-3 rounded-full shrink-0";

const pieLegendLabel = "text-muted-foreground flex-1 truncate";

const pieLegendValue = "font-semibold text-foreground";

const emptyState = cn(shared.colCenter, "py-10 text-muted-foreground");

const noData = "text-sm font-medium text-foreground mt-2";

const noDataHint = "text-xs text-muted-foreground mt-1 max-w-xs text-center";

const loadingSkeleton = "h-6 w-36 animate-pulse rounded bg-muted";

const emptyIcon = "h-10 w-10";

export {
  statsGrid,
  pageEnter,
  animateSlideUp,
  chartsGrid,
  chartCard,
  chartCardHeader,
  chartHeaderRow,
  chartHeaderIcon,
  chartTitle,
  gridLine,
  chartAxis,
  barFill,
  glassTooltip,
  tooltipLabel,
  tooltipRow,
  tooltipDot,
  tooltipValue,
  pieLegend,
  pieLegendItem,
  pieLegendDot,
  pieLegendLabel,
  pieLegendValue,
  emptyState,
  noData,
  noDataHint,
  loadingSkeleton,
  emptyIcon,
};
